// Copyright Epic Games, Inc. All Rights Reserved.

import enUs from "./en-US";
import arAr from "./ar-AR";
import deDe from "./de-DE";
import esEs from "./es-ES";
import esMx from "./es-MX";
import frFr from "./fr-FR";
import itIt from "./it-IT";
import jaJp from "./ja-JP";
import krKo from "./kr-KO";
import plPl from "./pl-PL";
import ptBr from "./pt-BR";
import ruRu from "./ru-RU";
import trTu from "./tr-TU";
import zhCn from "./zh-CN";
import zhTw from "./zh-TW";
import da from "./da";
import nl from "./nl";
import fi from "./fi";
import no from "./no";
import sv from "./sv";
import th from "./th";

export const initialLocalizationMessages = {
  "en-US": enUs,
  "ar-AR": arAr,
  "de-DE": deDe,
  "es-ES": esEs,
  "es-MX": esMx,
  "fr-FR": frFr,
  "it-IT": itIt,
  "ja-JP": jaJp,
  "kr-KO": krKo,
  "pl-PL": plPl,
  "pt-BR": ptBr,
  "ru-RU": ruRu,
  "tr-TU": trTu,
  "zh-CN": zhCn,
  "zh-TW": zhTw,
  da,
  nl,
  fi,
  no,
  sv,
  th,
};
